/**
 * PreferenceRow.tsx - Reusable preference row with label, description, and toggle
 * Used for settings like assignment reminders, SMS opt-in, etc.
 */
import React from "react";
import { View } from "react-native";
import CustomText from "../../../common/general/CustomText/CustomText";
import CustomSwitch from "../../../common/general/CustomSwitch/CustomSwitch";
import { spacing, colors } from "../../../../styles/design-system";

export interface PreferenceRowProps {
  titleKey: string;
  descriptionKey: string;
  value: boolean;
  onValueChange: (value: boolean) => void;
  switchSize?: "m" | "l";
  useTranslationText?: boolean;
}

function PreferenceRow({
  titleKey,
  descriptionKey,
  value,
  onValueChange,
  switchSize = "l",
  useTranslationText = true,
}: PreferenceRowProps) {
  return (
    <View
      style={[
        {
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "flex-start",
          paddingVertical: spacing.sm,
          gap: spacing.md,
          marginBottom: spacing.md,
        },
      ]}
    >
      <View style={[{ flex: 1, gap: spacing.xxs }]}>
        <CustomText
          text={titleKey}
          size="m"
          weight="medium"
          style={[{ color: colors.grey[900] }]}
          useTranslationText={useTranslationText}
        />
        {descriptionKey && (
          <CustomText
            text={descriptionKey}
            size="s"
            style={[{ color: colors.grey[600], lineHeight: 1.2 * 20 }]}
            useTranslationText={useTranslationText}
          />
        )}
      </View>
      <CustomSwitch
        value={value}
        onValueChange={onValueChange}
        size={switchSize}
      />
    </View>
  );
}

export default PreferenceRow;
